function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="15" height="15" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12.667.29L7.5 5.455 2.333.29a.955.955 0 0 0-1.369 0L.289.964a.955.955 0 0 0 0 1.369L5.456 7.5.29 12.667a.955.955 0 0 0 0 1.369l.675.675a.955.955 0 0 0 1.369 0L7.5 9.544l5.167 5.167a.955.955 0 0 0 1.369 0l.675-.675a.955.955 0 0 0 0-1.369L9.544 7.5l5.167-5.167a.955.955 0 0 0 0-1.369l-.675-.675a.955.955 0 0 0-1.369 0z" fill="#278C7E" /></svg>;
});